module.exports = __webpack_public_path__ + "static/img/v-qbs09.61a7dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/v-qbs09.png
// module id = Upv1
// module chunks = 1